import http from "./httpService";

// const Urlapi = "https://api-mobileapp.advanceagro.net";

export async function getYear(branchid) {
  return http.get("/wms/getYearBranch?branchid=" + branchid);
}
export async function getPerformace(
  branchid,
  year = 0,
  month = 0,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    "/wms/getPerformace?branchid=" +
      branchid +
      "&year=" +
      year +
      "&month=" +
      month +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}
export async function getPerFormacePerMonth(
  branchid,
  year = 0,
  month = 0,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    "/wms/getPerFormacePerMonth?branchid=" +
      branchid +
      "&year=" +
      year +
      "&month=" +
      month +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}
export async function getPerformaceMinutes(
  branchid,
  year = 0,
  month = 0,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    "wms/getPerformaceMinutes?branchid=" +
      branchid +
      "&year=" +
      year +
      "&month=" +
      month +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}

export async function getPerformaceMinutesPermonth(
  branchid,
  year = 0,
  month = 0,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    "wms/getPerformaceMinutesPermonth?branchid=" +
      branchid +
      "&year=" +
      year +
      "&month=" +
      month +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}
export async function getOnProcessOverDays(
  branchid,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    "wms/GetOnProcessTotal?branchid=" +
      branchid +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}
export async function getOnProcessDetails(
  branchid,
  typeid = 0,
  truckid = 0
) {
  return http.get(
    "wms/GetOnProcessDetails?branchid=" +
      branchid +
      "&typeid=" +
      typeid +
      "&truckid=" +
      truckid
  );
}

export async function getWoodRecieve(
  type="log",
  startDate,
) {
  return http.get(
    "/IPS/WoodReceiveDashboard?Type="+ type +"&StartDate="+startDate
  );
}
export async function getLogToProdue(
  branchid='501',
  startDate,
) {
  return http.get(
    "/IPS/WoodReceive?IPS/LogToProductiontatoomDetails"
  );
}
export async function getReport(
  RID="R02",
  startDate,
  id=1
) {
  return http.get(
    "/Report/ReportWoodChip?ReportCode="+RID +"&StartDate="+ startDate +"&EndDate="+ startDate +"&StorageID="+id
  );
}
export async function getReportdashbaod(
  RID="R05",
  startDate,
  id=1
) {
  return http.get(
    "/Report/ReportWoodChipDashboard?ReportCode="+RID +"&StartDate="+ startDate +"&EndDate="+ startDate +"&StorageID="+id
  );
}

export async function GetReport04Daily(
   startDate,EndDate,
  id=1
) {
  return http.get(
    "/report/GetReport04Daily?&StartDate="+ startDate +"&EndDate="+ EndDate +"&StorageID="+id
  );
}

export async function GetReport05Daily(
  startDate,EndDate,
 id=1
) {
 return http.get(
   "/report/GetReport05Daily?&StartDate="+ startDate +"&EndDate="+ EndDate +"&StorageID="+id
 );
}
// export default {
//   getYear,getOnProcessDetails,getOnProcessOverDays,
//   getPerformace,
//   getPerFormacePerMonth,
//   getPerformaceMinutes,
// };
